import React, { useEffect, useState } from 'react';
import './App.css';

const API_KEY = '03d54ac8-6659-11f1-8d28-066a7fa2e369';
const AVATAR_ID = '9ebd9d5a-efd4-433b-80ea-5884c7c68dcf';
const CONTEXT_ID = '9d3317d3-8ea6-43b1-8664-8dde43537f08';

function App() {
  const [streamingLink, setStreamingLink] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isExpanded, setIsExpanded] = useState(true);
  const [clientWidth, setClientWidth] = useState(window.innerWidth);

  useEffect(() => {
    const fetchEmbedUrl = async () => {
      try {
        const response = await fetch(
          'https://api.liveavatar.com/v2/embeddings?t=' + Date.now(),
          {
            method: 'POST',
            headers: {
              'X-API-KEY': API_KEY,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Cache-Control': 'no-cache, no-store, must-revalidate',
              'Pragma': 'no-cache',
            },
            body: JSON.stringify({
              avatar_id: AVATAR_ID,
              context_id: CONTEXT_ID,
            }),
          }
        );
        const data = await response.json();
        if (data.data && data.data.url) {
          // Force fresh URL by appending timestamp
          const freshUrl = data.data.url + '&t=' + Date.now();
          setStreamingLink(freshUrl);
        } else {
          setError('Failed to load avatar: ' + (data.message || 'Unknown error'));
        }
      } catch (err) {
        setError('Failed to connect to avatar service.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchEmbedUrl();
  }, []);

  useEffect(() => {
    const handleResize = () => setClientWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const Header = () => (
    <header className="app-header">
      <div className="logo">
        <img src="/Assets/logo.png" alt="People's Leasing Logo" />
      </div>
      <div className="header-icons">
        <div className="chatbot">
          <img src="/Assets/AI_ChatBot.png" alt="AI Chatbot Logo" style={{ pointerEvents: 'none' }} />
        </div>
      </div>
    </header>
  );

  return (
    <div className="app-container" style={{ backgroundImage: "linear-gradient(135deg, rgba(248, 250, 252, 0.82) 0%, rgba(226, 232, 240, 0.82) 100%), url('/Assets/bg.png')" }}>
      <Header />
      <div
        id="streaming-embed"
        className={`chat-embed visible ${isExpanded ? 'expanded' : ''}`}
        style={{
          margin: '0 auto',
          ...(isExpanded
            ? clientWidth < 540
              ? { height: 'calc(100vh - 120px)', width: 'calc(100% - 20px)' }
              : { height: '600px', width: 'calc(600px * 16 / 9)' }
            : { height: '180px', width: '180px' }),
        }}
      >
        <div id="streaming-container" className="chat-container">
          {isLoading && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#fff', fontSize: '16px' }}>
              Loading avatar...
            </div>
          )}
          {error && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#ff4444', fontSize: '16px' }}>
              {error}
            </div>
          )}
          {streamingLink && (
            <iframe
              key={streamingLink}
              src={streamingLink}
              title="LiveAvatar Embed"
              className="chat-iframe"
              allow="microphone"
              allowFullScreen={false}
              style={{ width: '100%', height: '100%', border: 'none' }}
            ></iframe>
          )}
        </div>
      </div>
      <div className="sections-container">
        <div className="chat-description">
          <h2>You're now chatting with the AI Avatar of People's Leasing & Finance PLC.</h2>
          <p>Do you have a question about our current Annual Report? Get real-time answers instantly.</p>
        </div>
        <div className="analysis-section">
          <p className="analysis-text">To Get In-depth Analysis Use Our ChatBot</p>
          <button
            className="chatbot-button"
            onClick={() => window.open('https://finsightc.plc.lk', '_blank')}
          >
            Go to ChatBot
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;